import { SORT_ORDER } from './constants';
export const getSortOrderArray = () => {
  try {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
    return JSON.parse(window.localStorage.getItem(SORT_ORDER)) || {};
  } catch (e) {
    return {};
  }
};